module.exports = __webpack_public_path__ + "assets/img/202108-4.91df17b0.png";